import React, { Component } from 'react'
import Firebase from "firebase/app"
import 'firebase/database'

import { FaSignInAlt } from 'react-icons/fa'

import CustomParkingPicker from '../components/Admin/CustomAdminComponents/CustomParkingPicker'
import VehiclePlateRegistration from '../components/Admin/CustomAdminComponents/VehiclePlateRegistration'
import ParkingRemove from '../components/Admin/CustomAdminComponents/ParkingRemove'

import {
    NOT_CHOOSEN_STATE,
    PLATE_REGISTERED_SUCCESS,
    FOUND_STATE,
    PLATE_FIELD
} from '../constants'

import {
    CHOOSE_AN_OPTION_TEXT, PARKINGS_HEADER, LOGOUT_TEXT
} from '../strings'

import {validateField} from '../utils'


class Parkings extends Component {

    constructor(props){
        super(props)

        this.state = {
            plateIn: "",
            selectedParkingId: null,
            parkings: {},
            reservedParkings: {},
            currentOccupation: {},
            errorMessages: {
                invalidPlate: false,
                notAvailableSpace: false,
                plateAlreadyRegister: false
            },
            parkingState: NOT_CHOOSEN_STATE,
        }

        this.reservationsHeaders = [
            {name: "Placa", small: true},
            {name: "Evento", small: true},
            {name: "Reservacion", small: true},
            {name: "Entrada esperada", small: true, render: 'date-time'},
            {name: "Entrada actual", small: true, render: 'date-time'},
            {name: "Salida esperada", small: true, render: 'date-time'}
        ]

        this.reservedParkingsRef = Firebase.database().ref('/reservedParkings')
        this.parkingsRef = Firebase.database().ref('/parkings')

        this.handleLogout = this.handleLogout.bind(this)
        this.handleParkingChange = this.handleParkingChange.bind(this)
        this.handlePlateInput = this.handlePlateInput.bind(this)
        this.handlePlateRegister = this.handlePlateRegister.bind(this)
        this.handleParkingEntryDelete = this.handleParkingEntryDelete.bind(this)

    }

    handleLogout(){
        localStorage.clear()
        this.props.history.push('/login')
    }

    handleParkingChange(event){
        const {reservedParkingsRef, parkingsRef} = this
        const value = event.target.value
        reservedParkingsRef.off()
        parkingsRef.off()

        if (value === CHOOSE_AN_OPTION_TEXT){
            this.setState({
                parkingState: NOT_CHOOSEN_STATE,
                selectedParkingId: null,
                reservedParkings: {},
                errorMessages: {
                    invalidPlate: false,
                    notAvailableSpace: false,
                    plateAlreadyRegister: false
                }
            })
            return
        }
        // Create a new listener on future reservedSpaces for this parking lot
        const nowTimestamp = new Date().getTime()
        reservedParkingsRef.child(`/${value}`).orderByKey().startAt(nowTimestamp.toString()).on(
            'value', snapshot => {
                var parkingsRaw = snapshot.val();
                if (parkingsRaw === null){
                    parkingsRaw = {}
                }
                this.setState({
                    reservedParkings: parkingsRaw
                })
        })

        parkingsRef.child(`/${value}/currentOccupation`).on('value', snapshot => {
            var occupationRaw = snapshot.val()
            if (occupationRaw === null){
                occupationRaw = {}
            }
            this.setState({
                currentOccupation: occupationRaw
            })
        })

        this.setState({
            parkingState: FOUND_STATE,
            errorMessages: {
                invalidPlate: false,
                notAvailableSpace: false,
                plateAlreadyRegister: false
            },
            selectedParkingId: value
        })
    }

    handlePlateInput(event){
        const {errorMessages} = this.state
        var value = event.target.value
        value = value.replace(/\s/g, '');

        errorMessages.invalidPlate = false
        errorMessages.plateAlreadyRegister = false
        const regexAlphaNum = /^[a-zA-Z]{3}$/
        if (regexAlphaNum.test(value)){
            // This is an alpha num plate, add - automatically
            value += "-"
        }
        if (!validateField(PLATE_FIELD, value) && value.length > 0){
            errorMessages.invalidPlate = true
        }

        this.setState({
            plateIn: value,
            parkingState: FOUND_STATE,
            errorMessages: errorMessages
        })

    }

    handlePlateRegister(){
        const {
            plateIn, errorMessages, selectedParkingId, parkings, currentOccupation
        } = this.state
        if (
            errorMessages.invalidPlate || errorMessages.plateAlreadyRegister
        ){
            return
        }
        if (Object.keys(currentOccupation).length >= parkings[selectedParkingId].capacity){
            errorMessages.notAvailableSpace = true
            this.setState({
                errorMessages: errorMessages
            })
            return
        }
        errorMessages.notAvailableSpace = false
        if (plateIn.length === 0){
            errorMessages.invalidPlate = true
            this.setState({
                errorMessages: errorMessages
            })
            return
        }
        const dbRef = Firebase.database().ref(
            `/parkings/${selectedParkingId}/currentOccupation/${plateIn.toLowerCase()}`
        )
        dbRef.once('value', snapshot => {
            var registeredPlate = snapshot.val()
            if (registeredPlate != null){
                errorMessages.plateAlreadyRegister = true
                this.setState({
                    errorMessages: errorMessages
                })
                return
            }
            dbRef.set(new Date().getTime())
            this.setState({
                plateIn: "",
                errorMessages: errorMessages,
                parkingState: PLATE_REGISTERED_SUCCESS
            })
        })

    }

    handleParkingEntryDelete(carPlate){
        const {selectedParkingId, errorMessages} = this.state
        const dbRef = Firebase.database().ref(
            `/parkings/${selectedParkingId}/currentOccupation/${carPlate}`
        )
        dbRef.remove()
        errorMessages.notAvailableSpace = false
        this.setState({
            errorMessages: errorMessages,
            parkingState: FOUND_STATE
        })

    }

    componentDidMount(){
        // Get all events
        const ref = Firebase.database().ref('/parkings')

        ref.on('value', snapshot => {
            var parkingsRaw = snapshot.val()
            if (parkingsRaw === null){
                parkingsRaw = {}
            }
            this.setState({
                parkings: parkingsRaw
            })
        })
    }

    render(){
        const {
            selectedParkingId,
            parkings,
            currentOccupation,
            reservedParkings,
            plateIn,
            errorMessages,
            parkingState
        } = this.state
        const {
            handleLogout,
            handleParkingChange,
            handlePlateInput,
            handlePlateRegister,
            handleParkingEntryDelete
        } = this
        return(
            <div>
                <div class="topnav">
                    <label>{PARKINGS_HEADER}</label>
                    <label type="button" className={"inactive"} onClick={handleLogout} >
                        <FaSignInAlt/>{LOGOUT_TEXT}
                    </label>
                </div>
                <div className="parking-picker">
                    <CustomParkingPicker
                        parkings={parkings}
                        selectedParkingId={selectedParkingId}
                        onParkingSelected={handleParkingChange}
                        disabled={false}
                    />
                </div>
                <div>
                {
                    selectedParkingId ?
                    <div className="parking-info-display">
                        <div className="parking-table-occupancy-box">
                            <p>
                                Espacios ocupados: {Object.keys(currentOccupation).length} (
                                de {parkings[selectedParkingId].capacity})
                            </p>
                        </div>
                    </div> : <div className="parking-info-display-void"></div>
                }
                </div>
                <div className="shadow-box"></div>
                {
                    selectedParkingId ?
                    <div className="parking-info-display">
                        <VehiclePlateRegistration
                            plate={plateIn}
                            reservedParkings={reservedParkings}
                            onPlateChange={handlePlateInput}
                            onEnterClick={handlePlateRegister}
                            state={parkingState}
                            errorMessages={errorMessages}
                        />
                    </div> : <div></div>
                }
                {
                    selectedParkingId ?
                    <div className="shadow-box"></div>: <div></div>
                }
                {
                    selectedParkingId ?
                    <div className="parking-info-display">
                        <ParkingRemove
                            currentOccupation={currentOccupation}
                            onDeleteRecord={handleParkingEntryDelete}
                        />
                    </div> :<div></div>
                }
            </div>
        )
    }
}

export default Parkings
